import { Component, OnInit } from '@angular/core';
import { User } from '../models/user.model';
import { UserService } from '../services/user.service';


@Component({
  selector: 'app-users',
  templateUrl: './users.component.html',
  styleUrls: ['./users.component.scss']
})
export class UsersComponent implements OnInit {
  users: User[] = [];
  searchText: string = '';
  loading: boolean = true;

  constructor(private userService: UserService) { }

  ngOnInit(): void {
    this.loadUsers();
  }

  loadUsers() {
    this.loading = true;
    this.userService.getUsers().subscribe({
      next: (res) => {
        this.users = res;
        this.loading = false;
      },
      error: (err) => {
        console.error('Error fetching users', err);
        this.loading = false;
      }
    });
  }

  search() {
    if (!this.searchText) {
      this.loadUsers();
      return;
    }
    this.users = this.users.filter(u =>
      u.email.toLowerCase().includes(this.searchText.toLowerCase()) ||
      u.role.toLowerCase().includes(this.searchText.toLowerCase())
    );
  }

  changeRole(user: User, newRole: string) {
    this.userService.updateUserRole(user.id, newRole).subscribe({
      next: () => this.loadUsers(),
      error: (err) => console.error('Role update failed', err)
    });
  }

  toggleActive(user: User) {
    this.userService.toggleActive(user.id).subscribe({
      next: () => this.loadUsers(),
      error: (err) => console.error('Status update failed', err)
    });
  }

  deleteUser(user: User) {
    if (!confirm(`Are you sure you want to delete ${user.email}?`)) return;
    this.userService.deleteUser(user.id).subscribe({
      next: () => this.loadUsers(),
      error: (err) => console.error('Delete failed', err)
    });
  }
}

